/*
 * =============================================================================
 * Project: admin_panel
 * Created Date: 2018-03-15, 16:08:56
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-16, 12:47:23
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

/**
 * Is this field required?
 * 
 * @export
 * @param {string} [message="Pole jest wymagane!"] 
 * @returns 
 */
export function required(message = "Pole jest wymagane!") {
  return {
    required: true,
    message
  };
}


/**
 * Check is value contain only numbers.
 * 
 * @export
 * @param {any} rule 
 * @param {any} value 
 * @param {any} callback 
 */
export function allowedOnlyNumbers(rule, value, callback) {
  if (!/^[0-9]+$/.test(value)) {
    callback('Dozwolone są tylko cyfry.');
  } else {
    callback();
  }
}

/**
 * Check is value contain only signed numbers.
 * 
 * @export
 * @param {any} rule 
 * @param {any} value 
 * @param {any} callback 
 */
export function allowedOnlyIntegers(rule, value, callback) {
  if (!/^[+\-]?[0-9]+$/.test(value)) {
    callback('Dozwolone są tylko wartości całkowite.');
  } else {
    callback();
  }
}

/**
 * Check value is password has correct format.
 * 
 * @export
 * @param {any} rule 
 * @param {any} value 
 * @param {any} callback 
 */
export function checkPasswordRules(rule, value, callback) {
  if(typeof value === 'undefined') {
    callback();
  } else if(value.length < 8) {
    callback('Hasło nie może być krótsze niż 8 znaków.');
  } else if(!/[A-Z]/.test(value)) {
    callback('Hasło musi zawierać jedną wielką literę.');
  } else if(!/\d/.test(value)) {
    callback('Hasło musi zawierać jedną cyfrę');
  } else if(/[ęóąśłżźćńĘÓĄŚŁŻŹĆŃ ]/.test(value)) {
    callback('Hasło nie może zawierać specjalnych znaków');
  } else {
    callback();
  }
}

/**
 * The rule that must be email.
 * 
 * @export
 * @param {string} [message='Błędny format email!'] 
 * @returns 
 */
export function email(message = "Błędny format email!") {
  return {
    type: "email",
    message
  };
}


// WEBPACK FOOTER //
// ./src/rcapp/helpers/rules.js